"use no memo";

import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

export default function PDFViewer({ pdfBlob }: { pdfBlob: Blob }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const pdfUrl = URL.createObjectURL(pdfBlob);

  return <iframe src={pdfUrl} width="100%" height="500"></iframe>;

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
      <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
    </Worker>
  );
}
